var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollarIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3327 10.0003C18.3327 14.6027 14.6017 18.3337 9.99935 18.3337C5.39697 18.3337 1.66602 14.6027 1.66602 10.0003C1.66602 5.39795 5.39697 1.66699 9.99935 1.66699C14.6017 1.66699 18.3327 5.39795 18.3327 10.0003Z",
    stroke: "white",
    strokeWidth: 1.67
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2578 8.38457C12.1753 7.74902 11.4455 6.72217 10.1333 6.72215C8.60868 6.72212 7.96715 7.56654 7.83697 7.98875C7.63389 8.55349 7.6745 9.71457 9.4616 9.84116C11.6955 9.99949 12.5904 10.2632 12.4766 11.6303C12.3627 12.9974 11.1174 13.2928 10.1333 13.2611C9.14918 13.2295 7.53905 12.7774 7.47656 11.5614M9.97718 5.83203V6.72517M9.97718 13.2529V14.1653",
    stroke: "white",
    strokeWidth: 1.67,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarIconWhite);
export default __webpack_public_path__ + "static/media/dollar-icon-white.191c11e51ef0e3f61fa6abd73012f9ea.svg";
export { ForwardRef as ReactComponent };